import { reactive, ref } from 'vue';
import { DepartmentsModel } from '@/models';
import { DepartmentService } from '@/services';

export default () => {
  const departments = reactive(new DepartmentsModel(DepartmentService.getRegionsList(),
    DepartmentService.getCitiesList(),
    DepartmentService.getPlacesList()));
  function goToRegionPage(url) {
    if (url !== '0') window.location = url;
  }
  const currentDepartementVaccinat = DepartmentService.getCurrentDepartment();
  const currentDepartmentParts = DepartmentService.getCurrentDepartment();
  const currentDepartment = currentDepartmentParts && currentDepartmentParts.length ? ref(currentDepartmentParts) : ref('');
  const currentDepartementVaccination = currentDepartementVaccinat && currentDepartementVaccinat.length ? ref(currentDepartementVaccinat) : ref('');
  return {
    listRegion: departments.getRegions(),
    listCities: departments.getCities(),
    listPlaces: departments.getPlaces(),
    goToRegionPage,
    currentDepartment,
    currentDepartementVaccination,
  };
};
